import { useEffect, useState, useRef, useContext, createContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Select from 'react-select';

import styles from "./IndEvent.module.css"
import guestii from '../../assets/images/logos/guestii.svg'
import guestii_gif from '../../assets/images/guestii_gif.gif'
import { PromoterLimits } from './EditTeamModules'


const InviteTeam = ({ event, setMainReloadKey, handleClose, setSettingLimits, settingLimits, teamSelected, setTeamSelected, setLoadedOnce, loadedOnce }) => {
	const param = useParams();
	const [isLoading, setIsLoading] = useState(false)
	const [validationError, setValidationError] = useState(null)
  	const [searchableTeamMembers, setSearchableTeamMembers] = useState([])


	useEffect(() => {
		const handleTeamMembers = async () => {
			setIsLoading(true)

			const userId = localStorage.getItem("_id")
			const expiry = localStorage.getItem("expiry")
			if (!userId || !expiry) {
				locationStorage.removeItem("_id")
				locationStorage.removeItem("expiry")
				window.location = "/connect"
			}

			try {
				const retrieve = await axios.get(`/api/team/get-team-members/${userId}/${expiry}/${true}`);
				const eventTeamMembers = event.team.map(t => t.team_member._id.toString())
				const availableMembers = retrieve.data.teamMembers.filter(t => t.role.name !== "SuperAdmin" && !eventTeamMembers.includes(t._id.toString()))

				setSearchableTeamMembers(availableMembers)
			} catch (e) {
				localStorage.removeItem("_id")
				localStorage.removeItem("expiry")
				window.location = "/connect"
			}

			setIsLoading(false)
		}

		if (loadedOnce) { return; }
		handleTeamMembers()
		setLoadedOnce(true)
	}, [])

  	const handleSubmit = async () => {
		setIsLoading(true)

		const userId = localStorage.getItem("_id")
		const expiry = localStorage.getItem("expiry")
		if (!userId || !expiry) {
			localStorage.removeItem("_id")
			localStorage.removeItem("expiry")
			window.location = "/connect"
		}


	  	try {
	  		const body = {
	  			team: teamSelected
	  		}

		    const res = await axios.post(`/api/events/invite-team/${param.event_id}`, body, {
		      	headers: {
		        	'x-user-id': userId,
		        	'x-expiry': expiry
		      	}
		    });

		    setMainReloadKey((prevKey) => prevKey + 1);
		    handleClose(true)
	  	} catch (err) {
			localStorage.removeItem("_id")
			localStorage.removeItem("expiry")
			window.location = "/connect"
	  	}

  		setIsLoading(false)
  	}

  	const openBulkLimits = async () => {
  		const checkForTypes = [ ...teamSelected.filter(t => t.role === "Promoter") ]
  		setSettingLimits(checkForTypes)
  	}

	return (
		<div className={`${styles.popup_container_ind_team}`}>
			<div className={styles.promoters_layout}>
				<button className={styles.ind_close_ind} onClick={() => handleClose()}><i className={`fa-solid fa-xmark ${styles.s1}`}></i></button>

				<div className={styles.new_banner}>
					<div className={styles.new_title}>
						<p className={styles.bold}>Invite Team Members</p>
						<p className={styles.s1}>Use this module to invite your team!</p>
					</div>

					<div className={styles.banner_progress}>
						<div className={`${styles.progress_circle} ${styles.progress_circle_active}`}>
							<i className={`fa-solid fa-envelope ${styles.m1}`}></i>
						</div>
					</div>
				</div>

				<div className={styles.promoters_form_container}>
					{!isLoading
						?
							<>
								<Select
									isMulti={true}
									options={searchableTeamMembers.map(item => { return {
									    value: item._id.toString(),
									    first_name: item.first_name,
									    last_name: item.last_name,
									    email: item.email,
									    role: item.role.name
									} })}
									closeMenuOnSelect={true}
									isDisabled={validationError}
								    formatOptionLabel={(option, { context }) => {
								        if (context === 'menu') {
								          	return (
								            	<div>
								            		<div style={{ display: 'flex', alignItems: 'center', columnGap: '.75rem' }}>
								            			<div className={styles.guestii_profile_rounded}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>
								            			<div>
									              			<p className={styles.s1}>{option.first_name} {option.last_name}</p>
									              			<p className={styles.xs3}>{option.email}</p>
									              		</div>
								              		</div>

								              		<p className={styles.s1} style={{ marginTop: 10 }}>{option.role}</p>
								            </div>
								          )
								        }

								        return <div>{option.first_name} {option.last_name}</div>
								    }}
									styles={{
										control: (base, { isFocused }) => ({
											...base,
											height: 50,
											backgroundColor: '#01000D',
											borderRadius: 10,
											borderWidth: 3,
											borderStyle: 'solid',
											borderColor: validationError
												? 'red'
												: isFocused
												? 'rgba(68,157,209,1)'
												: 'rgba(68,157,209,0.3)',
											'&:hover': isFocused
												? { borderColor: 'rgba(68,157,209,1)' }
												: { borderColor: 'rgba(68,157,209,0.3)' }
										}),
										input: (base) => ({ ...base, color: '#fff' }),
										placeholder: (base) => ({ ...base, color: '#aaa' }),
									    multiValue: (base) => ({
									      	...base,
									      	backgroundColor: 'rgba(68,157,209,1)'
									    }),
									    multiValueRemove: (base) => ({
									      	...base,
									      	cursor: 'pointer',
									    }),
										multiValueLabel: (base) => ({ 
											...base,
											backgroundColor: "rgba(68,157,209,1)",
											color: '#fff'
										}),
										menu: (base) => ({
											...base,
											backgroundColor: '#161824',
											color: '#fff',
										}),
										menuList: (base) => ({
											...base,
											padding: "10px 0",
											height: 300,
										}),
									    option: (base, { isFocused }) => ({
									      	...base,
									      	backgroundColor: isFocused
									        	? 'rgba(68,157,209,1)'
									        	: 'transparent',
									      	color: '#fff',
									      	cursor: 'pointer',
									      	borderRadius: 7.5,
									      	'&:active': {
									        	backgroundColor: 'rgba(68,157,209,0.8)',
									      	},
									    }),
									}}
									onChange={(selected) => setTeamSelected(selected)}
									value={teamSelected && teamSelected}
								/>

								{(teamSelected && teamSelected.length > 0 && teamSelected.filter(t => t.role === "Promoter").length > 0) &&
					            	<div className={`${styles.team_checked_actions} ${styles.fadeContainer}`}>
										<button className={`${styles.guestiis_checked_action_btn}`} onClick={() => openBulkLimits()}>
											<p className={styles.xs3}>Limits</p>
										</button>
									</div>
								}
							</>
						:
					        <div className={styles.loading_text_layout_small}>
					            <img src={guestii_gif}/>
					        </div>
					}
				</div>

				{(teamSelected && teamSelected.length > 0) &&
					<div className={styles.submit_guestiis_btn_container}>
						<button className={`${styles.submit_guestiis_btn}`} onClick={() => handleSubmit()} disabled={isLoading}>
							<p className={styles.xs3}>Invite</p>
						</button>
					</div>
				}
			</div>
		</div>
	)
}


const InviteTeamModule = ({ event, setMainReloadKey, setInvitingTeam, selectedTeam, setSelectedTeam, teamSelected, setTeamSelected }) => {
	const [settingLimits, setSettingLimits] = useState([])
	const [loadedOnce, setLoadedOnce] = useState(false)


	const handleClose = async (bypass=false) => {
		if (settingLimits.length > 0) {
			setSettingLimits([])
		} else {
			if (teamSelected.length > 0 && !bypass) {
				const confirm = await window.confirm("Are you sure you want to discard these Team invites?")
				if (confirm) {
					setInvitingTeam(false)
					setTeamSelected([])
				}
			} else {
				setInvitingTeam(false)
				setTeamSelected([])
			}
		}
	}


	return (
		<>
			{settingLimits.length > 0
				?
					<PromoterLimits
						handleClose={handleClose}
						settingLimits={settingLimits}
						setTeamSelected={setTeamSelected}
						teamSelected={teamSelected}
					/>
				:
					<InviteTeam
						event={event}
						setMainReloadKey={setMainReloadKey}
						handleClose={handleClose}
						setSettingLimits={setSettingLimits}
						settingLimits={settingLimits}
						teamSelected={teamSelected}
						setTeamSelected={setTeamSelected}
						setLoadedOnce={setLoadedOnce}
						loadedOnce={loadedOnce}
					/>
			}
		</>
	);
};

export default InviteTeamModule;